import React from "react";

const DealsSVG = ({ activeSvgColor }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.2377 4.55C17.1502 4.4625 16.9752 4.375 16.8877 4.375C17.5877 3.9375 18.0252 3.2375 18.0252 2.3625C18.0252 1.05 16.9752 0 15.6627 0C14.3502 0 13.3002 1.05 13.3002 2.3625C13.3002 3.2375 13.7377 3.9375 14.4377 4.375C13.4752 4.725 12.8627 5.6 12.0752 6.5625L10.7627 8.31253L12.0752 10.2375L13.9127 8.83753V17.325C13.9127 18.2875 14.6127 19.1625 15.5752 19.25C16.1002 19.25 16.6252 19.075 16.9752 18.725C17.3252 18.375 17.5002 17.9375 17.5002 17.4125V12.8625L18.6377 11.55C19.0752 10.9375 19.3377 10.2375 19.3377 9.53753V7.78753C19.2502 6.3875 18.5502 5.075 17.2377 4.55Z"
        fill={activeSvgColor}
      />
      <path
        d="M9.625 9.62503L7.2625 6.5625C6.475 5.6 5.8625 4.725 4.9 4.375C5.6 3.9375 6.0375 3.2375 6.0375 2.3625C6.0375 1.05 4.9 0 3.5875 0C2.3625 0 1.225 1.05 1.225 2.3625C1.225 3.2375 1.6625 3.9375 2.3625 4.375C2.275 4.375 2.1875 4.4625 2.1 4.4625C0.7875 4.9875 0 6.3875 0 7.78753V9.53753C0 10.2375 0.2625 11.025 0.7 11.55L1.8375 12.8625V17.4125C1.8375 17.9375 2.0125 18.375 2.3625 18.725C2.7125 19.075 3.15 19.25 3.5875 19.25C4.55 19.25 5.425 18.4625 5.425 17.4125V8.83753L9.0125 11.55C9.1875 11.725 9.625 11.725 9.8875 11.55C10.325 11.375 10.5 10.7625 10.15 10.325L9.625 9.62503Z"
        fill={activeSvgColor}
      />
    </svg>
  );
};

export default DealsSVG;
